var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-700 spacex-4 vertical-centering"},[_c('CheckIcon'),_c('span',[_vm._v(_vm._s(_vm.success || _vm.$t('Changes have been successfully saved')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }